import React from "react";

export default function BottomBar() {
  return (
    <div className="bottombarNarrow">
      <div className="flexbox">
        <div className="item">Icons created by Freepik - Flaticon</div>
      </div>
    </div>
  );
}
